<template>
  <div id="AddCourseGradeDialog" class="wrap">

    <v-app-bar extended extension-height="10" class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Add Grade</span>
        <v-layout row align-baseline class=" ">
            <span class="subheading grey--text">{{semester.semester_academic_status}} Year </span>
            <span class=" subheading ml-1 grey--text ">{{semester.semester_term}}</span>
            <span class=" ml-1 grey--text ">{{semester.semester_year | moment("YYYY")}}</span>
          </v-layout>
      </v-layout>
    </v-app-bar>

    <div class="maxContainer">
     <v-card class=" mb-5 pt-5 offset-md-3 col-md-6 offset-sm-2 col-sm-8" flat style="marginTop:55px;">


      <v-card-text class="mt-0 pt-0 px-0">
        <v-container  grid-list-md pt-0 >
           <div @click="back" class="headerFake__back">
            <a class="headerFake__backLink">
              <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
              <span class="headerFake__backText">Back</span>
            </a>
          </div>
          <v-form>
            <v-layout column align-center class="justify-center hidden-sm-and-down mb-3">
        <span class="title light-blue--text text--darken-3 text-center">Add Grade</span>
        <v-layout row align-baseline class=" ">
            <span class="subheading grey--text">{{semester.semester_academic_status}} Year </span>
            <span class=" subheading ml-1 grey--text ">{{semester.semester_term}}</span>
            <span class=" ml-1 grey--text ">{{semester.semester_year | moment("YYYY")}}</span>
          </v-layout>
      </v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="course.course_name"
                color="green"
                readonly
                outlined
                hide-details
                >

              </v-text-field>
            </v-flex>



            <!-- Course Grade -->
            <v-flex xs12 v-if="!course.pass_fail_course" >

              <v-autocomplete
                v-model="course_grade"
                class="mt-4 pt-0"
                :items="['A+', 'A', 'A-', 'AB', 'B+', 'B', 'B-', 'BC', 'C+', 'C', 'C-', 'CD', 'D+', 'D', 'D-', 'F', 'W']"
                label="Course Grade"
                color="green"
                hide-details
                clearable
                outlined
              ></v-autocomplete>

            </v-flex>

            <v-layout v-if="course.course_lab === 'true'" column  mt-0  mb-2 >
              <v-autocomplete
                v-if="semester.semester_completion_status === 'Completed' "
                v-model="lab_grade"
                class="mt-5 pt-0"
                :items="['A+', 'A', 'A-', 'AB', 'B+', 'B', 'B-', 'BC', 'C+', 'C', 'C-', 'CD', 'D+', 'D', 'D-', 'F', 'W']"
                label="Lab Grade"
                 persistent-hint
                 hint="Leave blank if lab grade included with course"
                color="green"
                clearable
                outlined
                :disabled="course.pass_fail_course === true"
              ></v-autocomplete>





            </v-layout>



            <!-- Pass/Fail Grade -->
            <v-flex xs12 v-if="course.pass_fail_course" >

              <v-autocomplete
                v-model="pass_fail_grade"
                class="mt-2 pt-0"
                :items="['Pass','Fail']"
                label="Pass/Fail Grade"
                color="green"
                clearable
                outlined
              ></v-autocomplete>

            </v-flex>


          </v-form>


          <!-- Add Course Button -->
          <v-layout row >

            <v-btn
              class="mt-5"
              color="green"
              @click="addGrade"
              block
              large
              depressed

            >

              <span class="white--text"> Add Grade</span>
            </v-btn>

          </v-layout>
        </v-container>
       </v-card-text>
    </v-card>
    </div>


     <!-- Back Button -->
        <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>
</template>

<script>
export default {
  data() {
    return {
      course_grade: '',
      pass_fail_grade: '',
      lab_grade: ''
    }
  },
  methods: {
     back() {
        this.$router.go(-1)
      },
      addGrade() {

          if(this.pass_fail_grade === 'Pass') {
            this.pass_fail_grade = "true"
          }
           if(this.pass_fail_grade === 'Fail') {
            this.pass_fail_grade = "false"
          }

         const courseData = {
          collegeId: this.collegeId,
          semesterId: this.semesterId,
          id: this.courseId,
          course_grade: this.course_grade,
          lab_grade: this.lab_grade,
          lab_credits: this.course.lab_credits,
          quarter_credits: this.course.quarter_credits,
          lab_quarter_credits: this.course.lab_quarter_credits,
          course_id: this.course.course_id,
          course_name : this.course.course_name,
          course_lab: this.course.course_lab,
          course_credits: this.course.course_credits,
          online_course: this.course.online_course,
          pass_fail_course: this.course.pass_fail_course,
          pass_fail_grade: this.pass_fail_grade,
          course_gpa_calculation : this.course.course_gpa_calculation,
          course_subject_category: this.course.course_subject_category,

        }

        this.$store.dispatch('setUserCourseGrade', courseData)
        this.$router.go(-1)
        this.course_grade = '',
        this.pass_fail_grade = '',
        this.lab_grade = ''
      }
  },
  computed : {
    collegeId () {
      return this.$route.params.collegeId
    },
    semesterId () {
      return this.$route.params.semesterId
    },
    courseId () {
      return this.$route.params.courseId
    },
    college() {
      return this.$store.getters.loadedCollege(this.collegeId);
      },
     semester() {
       return this.college.semesters.find((semester) => {
          return semester.id === this.semesterId
        })
     },
     course() {

       return this.semester.courses.find(course => {
        return course.id === this.courseId
       })
     }
  }
}
</script>

<style scoped>
    #headerToolbar {
    position: sticky;
    box-shadow: 0 10px 30px -10px #11111130;
  }
   .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
  .maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
  padding-bottom:  40px;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
    margin-top: 8vh !important;
    
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Courses/AddCourseGradeDialog.vue